import React from 'react';

export function Loader() {
  return (
    <div className="h-96 flex flex-col items-center justify-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="101"
        fill="none"
      >
        <path
          fill="#A876F5"
          fillRule="evenodd"
          d="M33.31 67.946c0-.583.397-1.001 1.194-1.262 7.564-1.944 14.1-5.57 19.609-10.885 5.506-5.312 9.257-11.724 11.248-19.24.263-.777.698-1.165 1.293-1.165.6 0 1.027.388 1.295 1.165 1.991 7.516 5.738 13.928 11.248 19.24 5.506 5.315 12.11 8.94 19.809 10.885.663.26.994.679.994 1.262s-.331 1.005-.994 1.262c-7.698 2.076-14.303 5.769-19.809 11.08-5.51 5.314-9.257 11.724-11.248 19.24-.268.647-.696.972-1.295.972-.595 0-1.03-.325-1.293-.973-1.991-7.515-5.742-13.925-11.248-19.24-5.51-5.31-12.045-9.003-19.61-11.079-.796-.257-1.193-.68-1.193-1.262Z"
          clipRule="evenodd"
        />
        <path
          fill="#C29FF8"
          fillRule="evenodd"
          d="M0 35.227c0-.388.264-.646.797-.778 5.042-1.293 9.387-3.723 13.039-7.289 3.649-3.561 6.202-7.869 7.665-12.922.13-.517.398-.778.795-.778.4 0 .729.261.997.778 1.324 5.053 3.813 9.36 7.465 12.922 3.649 3.566 8.063 5.996 13.24 7.289.397.132.596.39.596.778 0 .39-.2.649-.597.777-5.176 1.428-9.59 3.92-13.239 7.484-3.652 3.563-6.141 7.807-7.465 12.73-.268.518-.597.777-.997.777-.397 0-.665-.26-.795-.778-1.463-4.922-4.017-9.166-7.665-12.73-3.652-3.563-7.997-6.056-13.04-7.483-.532-.128-.796-.388-.796-.777Z"
          clipRule="evenodd"
        />
        <path
          fill="#DCC8FB"
          fillRule="evenodd"
          d="M41.782 12.355c2.918-.648 5.407-2.008 7.466-4.083 2.057-2.07 3.484-4.532 4.28-7.385.264-.516.598-.516.995 0 .797 2.853 2.221 5.315 4.28 7.385 2.057 2.075 4.544 3.435 7.466 4.083.53.387.53.713 0 .97-2.922.778-5.409 2.173-7.466 4.18-2.058 2.01-3.483 4.44-4.28 7.288-.398.518-.731.518-.995 0-.796-2.849-2.223-5.279-4.28-7.289-2.06-2.006-4.548-3.4-7.466-4.179-.531-.257-.531-.582 0-.97Z"
          clipRule="evenodd"
        />
      </svg>
      <h2 className="text-h2 font-display mt-6">Generating...</h2>
    </div>
  );
}
